<template>
  <div class="blog-card">
    <div class="blog-card__top">
      <img src="@/assets/img/basin/basin-1.png" alt="yurtlarburada blog" class="blog-card__cover">
      <div class="blog-card__overlay">
      </div>
    </div>
    <div class="blog-card__cnt">
      <div class="blog-card__content">
        <div class="blog-card__date">{{ media.date }}</div>
        <div class="blog-card__title">{{ media.title }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MediaCard',
  props: {
    media: Object
  }
}
</script>

<style lang="scss">
</style>
